export enum HubspotWorkflowsRoutes {
  root = 'hubspot-workflows',
  view = 'view',
}
